import { render, staticRenderFns } from "./addLicenseModal.vue?vue&type=template&id=1f6d0c16&scoped=true"
import script from "./addLicenseModal.vue?vue&type=script&lang=js"
export * from "./addLicenseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d0c16",
  null
  
)

export default component.exports